// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mtf-modal {
  max-width: 980px;
}

.mtf-modal--wide {
  max-width: 1200px;
}

.mtf-panel-tabs {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--border);
  padding-bottom: 0.65rem;
}

.mtf-panel-tab {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 650;
  padding: 0.5rem 0.85rem;
  border: none;
  background: none;
  color: var(--text-muted);
  border-bottom: 3px solid transparent;
  margin-bottom: -0.65rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.mtf-panel-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.mtf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.mtf-tabs {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.mtf-tab {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
}

.mtf-tab--active {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.mtf-limit {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  font-weight: 650;
  color: var(--text-muted);
}

.mtf-limit select {
  padding: 0.35rem 0.55rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
}

.mtf-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 10px;
}

.mtf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.mtf-table th {
  text-align: left;
  padding: 0.7rem 0.85rem;
  background: #f8fafc;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
}

.mtf-table td {
  padding: 0.75rem 0.85rem;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

.mtf-empty {
  text-align: center;
  color: var(--text-muted);
  padding: 2rem 1rem !important;
}

.mtf-user {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.mtf-user span {
  font-size: 0.78rem;
  color: var(--text-muted);
}

.mtf-status {
  display: inline-flex;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
}

.mtf-status--active {
  background: #ecfdf5;
  color: #047857;
}

.mtf-status--paused {
  background: #fef3c7;
  color: #92400e;
}

.mtf-status--stopped {
  background: #f1f5f9;
  color: #64748b;
}

.mtf-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 0 1.1rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.mtf-pagination__btns {
  display: flex;
  gap: 0.4rem;
}

.mtf-pagination__btns button {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
}

.mtf-pagination__btns button:disabled {
  opacity: 0.45;
}

.mtf-status-select {
  padding: 0.35rem 0.55rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  font-family: inherit;
  font-size: 0.8rem;
}

.mtf-hint {
  margin: 0 0 0.75rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  line-height: 1.45;
}

.mtf-side--buy {
  color: #047857;
  font-weight: 700;
}

.mtf-side--sell {
  color: #b91c1c;
  font-weight: 700;
}

.mtf-status--order {
  background: #f1f5f9;
  color: #334155;
}

.mtf-status--placed {
  background: #ecfdf5;
  color: #047857;
}

.mtf-status--failed {
  background: #fee2e2;
  color: #b91c1c;
}

.mtf-status--completed {
  background: #ecfdf5;
  color: #047857;
}

.mtf-status--skipped {
  background: #fef3c7;
  color: #92400e;
}

.mtf-empty-block {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--text-muted);
}

.mtf-pnl-grid {
  display: grid;
  gap: 1rem;
}

.mtf-pnl-card h4 {
  margin: 0 0 0.65rem;
  font-size: 0.95rem;
}

.mtf-pnl-total {
  margin: 0 0 0.65rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.mtf-follow-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 260px;
}

.mtf-follow-list li {
  font-size: 0.75rem;
  line-height: 1.4;
}

.mtf-live,
.mtf-reason {
  display: block;
  color: var(--text-muted);
  margin-top: 0.1rem;
}

.mtf-follow-list .mtf-status {
  margin-left: 0.35rem;
}

.mtf-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.mtf-tile {
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.75rem 0.85rem;
}

.mtf-tile--primary {
  background: #f0fdfa;
  border-color: #a7f3d0;
}

.mtf-tile--mtm {
  background: #f8fafc;
}

.mtf-tile--mtm .mtf-tile__value {
  color: #64748b;
  font-weight: 650;
}

.mtf-mtm {
  color: #64748b;
  font-weight: 600;
}

.mtf-realized-cell {
  font-weight: 750;
}

.mtf-badge--mtm {
  background: #f1f5f9;
  color: #475569;
}

.mtf-row--mtm {
  background: #f8fafc;
}

.mtf-tile__label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.mtf-tile__value {
  font-size: 1.15rem;
  font-weight: 750;
  margin-top: 0.25rem;
}

.mtf-tile__live {
  font-size: 0.68rem;
  color: var(--text-muted);
  margin-top: 0.15rem;
}

.mtf-section-title {
  margin: 1.15rem 0 0.5rem;
  font-size: 0.95rem;
}

.mtf-refresh {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(15, 118, 110, 0.3);
  background: #f0fdfa;
  color: #0f766e;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
}

.mtf-refresh:disabled {
  opacity: 0.55;
}

.mtf-badge--realized {
  background: #ecfdf5;
  color: #047857;
}

.mtf-badge--live {
  background: #eff6ff;
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.mtf-pulse {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2563eb;
  animation: mtf-pulse 1.4s ease-in-out infinite;
}

@keyframes mtf-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.75);
  }
}

.mtf-row--live {
  background: #f8fbff;
}

.mtf-now {
  display: block;
  font-size: 0.7rem;
  color: var(--text-muted);
  font-weight: 500;
}

.mtf-est {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.mtf-est__tag {
  font-size: 0.68rem;
  color: #9a3412;
  font-weight: 650;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CopyTrading/MasterFollowersModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".mtf-modal {\n  max-width: 980px;\n}\n\n.mtf-modal--wide {\n  max-width: 1200px;\n}\n\n.mtf-panel-tabs {\n  display: flex;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid var(--border);\n  padding-bottom: 0.65rem;\n}\n\n.mtf-panel-tab {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 650;\n  padding: 0.5rem 0.85rem;\n  border: none;\n  background: none;\n  color: var(--text-muted);\n  border-bottom: 3px solid transparent;\n  margin-bottom: -0.65rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.mtf-panel-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.mtf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.mtf-tabs {\n  display: flex;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.mtf-tab {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n}\n\n.mtf-tab--active {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #047857;\n}\n\n.mtf-limit {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  font-weight: 650;\n  color: var(--text-muted);\n}\n\n.mtf-limit select {\n  padding: 0.35rem 0.55rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n}\n\n.mtf-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n}\n\n.mtf-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.mtf-table th {\n  text-align: left;\n  padding: 0.7rem 0.85rem;\n  background: #f8fafc;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  border-bottom: 1px solid var(--border);\n}\n\n.mtf-table td {\n  padding: 0.75rem 0.85rem;\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n}\n\n.mtf-empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem 1rem !important;\n}\n\n.mtf-user {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.mtf-user span {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n.mtf-status {\n  display: inline-flex;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.mtf-status--active {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.mtf-status--paused {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.mtf-status--stopped {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.mtf-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 0 1.1rem;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.mtf-pagination__btns {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.mtf-pagination__btns button {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n}\n\n.mtf-pagination__btns button:disabled {\n  opacity: 0.45;\n}\n\n.mtf-status-select {\n  padding: 0.35rem 0.55rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  font-family: inherit;\n  font-size: 0.8rem;\n}\n\n.mtf-hint {\n  margin: 0 0 0.75rem;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  line-height: 1.45;\n}\n\n.mtf-side--buy {\n  color: #047857;\n  font-weight: 700;\n}\n\n.mtf-side--sell {\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.mtf-status--order {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.mtf-status--placed {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.mtf-status--failed {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.mtf-status--completed {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.mtf-status--skipped {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.mtf-empty-block {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.mtf-pnl-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.mtf-pnl-card h4 {\n  margin: 0 0 0.65rem;\n  font-size: 0.95rem;\n}\n\n.mtf-pnl-total {\n  margin: 0 0 0.65rem;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.mtf-follow-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-width: 260px;\n}\n\n.mtf-follow-list li {\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n.mtf-live,\n.mtf-reason {\n  display: block;\n  color: var(--text-muted);\n  margin-top: 0.1rem;\n}\n\n.mtf-follow-list .mtf-status {\n  margin-left: 0.35rem;\n}\n\n.mtf-tiles {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n}\n\n.mtf-tile {\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 0.75rem 0.85rem;\n}\n\n.mtf-tile--primary {\n  background: #f0fdfa;\n  border-color: #a7f3d0;\n}\n\n.mtf-tile--mtm {\n  background: #f8fafc;\n}\n\n.mtf-tile--mtm .mtf-tile__value {\n  color: #64748b;\n  font-weight: 650;\n}\n\n.mtf-mtm {\n  color: #64748b;\n  font-weight: 600;\n}\n\n.mtf-realized-cell {\n  font-weight: 750;\n}\n\n.mtf-badge--mtm {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.mtf-row--mtm {\n  background: #f8fafc;\n}\n\n.mtf-tile__label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n}\n\n.mtf-tile__value {\n  font-size: 1.15rem;\n  font-weight: 750;\n  margin-top: 0.25rem;\n}\n\n.mtf-tile__live {\n  font-size: 0.68rem;\n  color: var(--text-muted);\n  margin-top: 0.15rem;\n}\n\n.mtf-section-title {\n  margin: 1.15rem 0 0.5rem;\n  font-size: 0.95rem;\n}\n\n.mtf-refresh {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 118, 110, 0.3);\n  background: #f0fdfa;\n  color: #0f766e;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  white-space: nowrap;\n}\n\n.mtf-refresh:disabled {\n  opacity: 0.55;\n}\n\n.mtf-badge--realized {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.mtf-badge--live {\n  background: #eff6ff;\n  color: #1d4ed8;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.mtf-pulse {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2563eb;\n  animation: mtf-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes mtf-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.4;\n    transform: scale(0.75);\n  }\n}\n\n.mtf-row--live {\n  background: #f8fbff;\n}\n\n.mtf-now {\n  display: block;\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.mtf-est {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.mtf-est__tag {\n  font-size: 0.68rem;\n  color: #9a3412;\n  font-weight: 650;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
